import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NoAccess } from '@/components/custom/no-access';
import { useMe } from '@/lib/me';

// Layout for /dashboards/* — every dashboard nests here and shares the gate.
//
// BOTH IDS, AND THE ORDER MATTERS. `dashboard.view` reaches the section;
// `report.view` is what the tiles' numbers are actually fetched under, and it
// carries the row scope. Someone holding only `dashboard.view` would open a
// frame whose every tile then refuses, so the narrower id is not enough on its
// own — it can subtract from `report.view`, never stand in for it.
//
// `report.view` is named first in the refusal because it is the one a user is
// more likely to be missing legitimately, and the one an admin has to grant
// first for the other to mean anything. See `permissions.ts`.
export const Route = createFileRoute('/_authenticated/dashboards')({
  component: DashboardsLayout,
});

function DashboardsLayout() {
  const { permissions, loading } = useMe();
  if (loading) return <Outlet />;
  if (!permissions.has('report.view')) {
    return <NoAccess permission="report.view" resource="Dashboards" />;
  }
  if (!permissions.has('dashboard.view')) {
    return <NoAccess permission="dashboard.view" resource="Dashboards" />;
  }
  return <Outlet />;
}
